<script>
import ListViewTemplate from './ListViewTemplate'

import Vue from 'vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

import feedbackMixin from '../mixins/feedback'
import listViewMixin from '../mixins/list-view'
import exportFileMixin from "../mixins/export-file";

Vue.use(VueAxios, axios);

export default {
	name: 'LineItems',
	mixins: [feedbackMixin, listViewMixin, exportFileMixin],
	extends: ListViewTemplate,
	data() {
		return {
			primaryKey: 'id',
			columns: [
				{
					name: 'Locked Container Line Item',
					displayName: 'Locked',
					sort: 0,
					locked: true
				},
				{
					name: 'id_Job',
					displayName: 'Job ID',
					sort: 0
				},
				{
					name: 'id',
					displayName: 'ID',
					sort: 0
				},
				{
					name: 'id_container',
					displayName: 'Cont ID',
					searchName: 'Container_PK_ID',
					sort: 0
				},
				{
					name: 'NDC Number',
					displayName: 'NDC Number',
					sort: 0
				},
				{
					name: 'NDC Schedule',
					displayName: 'Sch',
					searchName: 'Schedule',
					sort: 0,
					align: 'center'
				},
				{
					name: 'Containers::Container Name',
					displayName: 'Container Name',
					sort: 0
				},
				{
					name: 'NDC Description',
					displayName: 'Description',
					sort: 0
				},
				{
					name: 'Danox_Dictionary_Final_Code::Strength',
					displayName: 'Strength',
					sort: 0
				},
				{
					name: 'Pack Quantity',
					displayName: 'Pk Qty',
					searchName: 'Pack Qty',
					sort: 0,
					align: 'center'
				},
				{
					name: 'Pack Quantity UoM',
					displayName: 'UoM',
					searchName: 'Pack Qty UoM',
					sort: 0,
					align: 'center'
				},
				{
					name: 'Pack Size',
					displayName: 'Pack Size',
					sort: 0,
					align: 'center'
				},
				{
					name: 'Pack Size UoM',
					displayName: 'UoM',
					searchName: 'Pack Size UoM',
					sort: 0,
					align: 'center'
				},
				{
					name: 'Reporting Qty',
					displayName: 'Reporting Qty',
					sort: 0,
					align: 'center'
				},
				{
					name: 'Registration::Registration Number',
					displayName: 'Registration',
					sort: 0,
					align: 'center'
				},
				{
					name: 'Reporting UoM',
					displayName: 'UoM',
					searchName: 'Reporting Qty UoM',
					sort: 0,
					align: 'center'
				},
				{
					name: 'Percent Fill',
					displayName: '% Fill',
					sort: 0,
					format: '0.00%'
				},
				{
					name: 'Form 222 Number',
					displayName: 'Form 222#',
					sort: 0
				},
				{
					name: 'CWF Form Number',
					displayName: 'CWF#',
					sort: 0
				},
				{
					name: 'Source Number',
					displayName: 'Source Number',
					sort: 0
				},
				{
					name: 'Source',
					displayName: 'Source',
					sort: 0
				},
				{
					name: 'Cause',
					displayName: 'Cause',
					sort: 0
				},
				{
					name: 'Lot Number',
					displayName: 'Lot#',
					sort: 0
				},
				{
					name: 'Containers::Pallet',
					displayName: 'Pallet',
					sort: 0
				},
				{
					name: 'Job::Date Transfer',
					displayName: 'Transferred',
					sort: 0
				},
				{
					name: 'Job::Company ID',
					displayName: 'Comp ID',
					searchName: 'Company ID',
					sort: 0
				},
				{
					name: 'Job::Date Destroyed',
					displayName: 'Destroyed',
					sort: 0
				},
				{
					name: 'Date Created',
					displayName: 'Created',
					sort: 0
				},
				{
					name: 'Created By',
					displayName: 'By',
					searchName: 'Created By',
					sort: 0
				}
			],
			fields: [
				{
					key: 'lockedField',
					label: ''
				},
				{
					key: 'id',
					label: 'ID',
					sortable: true,
					stickyColumn: true
				},
				{
					key: 'id_container',
					label: 'Cont ID',
					searchName: 'Container_PK_ID',
					sortable: true
				},
				{
					key: 'id_Job',
					label: 'Job ID',
					sortable: true
				},
				{
					key: 'NDC Number',
					label: 'NDC Number',
					sortable: true
				},
				{
					key: 'NDC Schedule',
					label: 'Sch',
					searchName: 'Schedule',
					sortable: true,
					align: 'center'
				},
				{
					key: 'Containers::Container Name',
					label: 'Container Name',
					sortable: true
				},
				{
					key: 'NDC Description',
					label: 'Description',
					sortable: true
				},
				{
					key: 'Danox_Dictionary_Final_Code::Strength',
					label: 'Strength',
					sortable: true
				},
				{
					key: 'Pack Quantity',
					label: 'Pk Qty',
					searchName: 'Pack Qty',
					sortable: true,
					align: 'center'
				},
				{
					key: 'Pack Quantity UoM',
					label: 'UoM',
					searchName: 'Pack Qty UoM',
					sortable: true,
					align: 'center'
				},
				{
					key: 'Pack Size',
					label: 'Pack Size',
					sortable: true,
					align: 'center'
				},
				{
					key: 'Pack Size UoM',
					label: 'UoM',
					searchName: 'Pack Size UoM',
					sortable: true,
					align: 'center'
				},
				{
					key: 'Reporting Qty',
					label: 'Reporting Qty',
					sortable: true,
					align: 'center'
				},
				{
					key: 'Registration::Registration Number',
					label: 'Registration',
					sortable: true,
					align: 'center'
				},
				{
					key: 'Reporting UoM',
					label: 'UoM',
					searchName: 'Reporting Qty UoM',
					sortable: true,
					align: 'center'
				},
				{
					key: 'Percent Fill',
					label: '% Fill',
					sortable: true,
					format: '0.00%'
				},
				{
					key: 'Form 222 Number',
					label: 'Form 222#',
					sortable: true
				},
				{
					key: 'CWF Form Number',
					label: 'CWF#',
					sortable: true
				},
				{
					key: 'Source Number',
					label: 'Source#',
					sortable: true
				},
				{
					key: 'Lot Number',
					label: 'Lot#',
					sortable: true
				},
				{
					key: 'Containers::Pallet',
					label: 'Pallet',
					sortable: true
				},
				{
					key: 'Job::Date Transfer',
					label: 'Transferred',
					sortable: true
				},
				{
					key: 'Job::Company ID',
					label: 'Comp ID',
					searchName: 'Company ID',
					sortable: true
				},
				{
					key: 'Job::Date Destroyed',
					label: 'Destroyed',
					sortable: true
				},
				{
					key: 'Date Created',
					date: true,
					label: 'Created',
					sortable: true
				},
				{
					key: 'Created By',
					label: 'By',
					searchName: 'Created By',
					sortable: true
				}
			],
			headerTitle: 'Line Items',
			restEntity: 'line-items',
			restDetailEntity: 'line-item-view',
			showExport: true,
			leftmostColumn: 'cell(id)',
			lockedColumn: 'Locked Container Line Item'
		}
	},
}
</script>
<style scoped>
</style>